import {Component, OnInit} from '@angular/core';
import {EiImportTypeBaseComponent} from "../ei-import-type-base.component";


@Component({
    selector: 'ei-import-type-full',
    templateUrl: 'ei-import-type-full.component.html',
    standalone: false
})
export class EiImportTypeFullComponent extends EiImportTypeBaseComponent implements OnInit {


    ngOnInit() {
        super.ngOnInit();
    }

}
